const footerCols = [
  {
    title: "玩法",
    links: ["吃瓜王答题", "吃瓜王测试", "吃瓜王闯关", "吃瓜王考察"],
  },
  {
    title: "内容",
    links: ["今日瓜田", "热评现场", "段位榜", "冷知识专栏"],
  },
  {
    title: "关于",
    links: ["关于我们", "题目反馈", "品牌合作", "联系我们"],
  },
];

export default function CtaFooter() {
  return (
    <footer>
      {/* CTA band */}
      <div className="relative w-full overflow-hidden bg-primary-600">
        <div className="pointer-events-none absolute -left-16 -top-20 h-64 w-64 rounded-full bg-primary-400/40 blur-2xl" />
        <div className="pointer-events-none absolute -bottom-24 right-10 h-72 w-72 rounded-full bg-accent-400/30 blur-2xl" />
        <div className="shell relative py-14 md:py-16">
          <div className="flex flex-col items-start gap-6 lg:flex-row lg:items-center lg:justify-between">
            <div className="max-w-2xl">
              <p className="inline-flex items-center gap-1.5 rounded-full bg-primary-950/20 px-3 py-1 text-xs font-bold text-accent-200">
                <i className="ri-trophy-line text-sm" aria-hidden="true" />
                本周瓜王挑战赛进行中
              </p>
              <h2 className="mt-4 font-heading text-2xl font-black leading-tight tracking-tight text-background-50 md:text-4xl">
                敢不敢现在就开一局，
                <span className="text-accent-300">证明你是懂瓜的？</span>
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-primary-100/90 md:text-base">
                不限时间、不收门票，下班放学路上也能随手挑战。答完这局，明早就轮到你在饭桌上当科普担当。
              </p>
            </div>
            <div className="flex shrink-0 flex-col gap-3 sm:flex-row">
              <a href="#play" className="inline-flex items-center justify-center whitespace-nowrap rounded-md bg-background-50 px-6 py-3.5 text-base font-black text-primary-700 transition-colors hover:bg-accent-400 hover:text-primary-950 cursor-pointer">
                <i className="ri-play-circle-line mr-2 text-lg" aria-hidden="true" />
                立即开玩
              </a>
              <a href="#feed" className="inline-flex items-center justify-center whitespace-nowrap rounded-md border border-background-50/40 px-6 py-3.5 text-base font-bold text-background-50 transition-colors hover:border-accent-300 hover:text-accent-200 cursor-pointer">
                先看热评
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* footer */}
      <div className="w-full bg-background-200">
        <div className="shell py-12 md:py-14">
          <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-5">
            <div className="lg:col-span-2">
              <a href="#top" className="flex items-center gap-2.5 cursor-pointer">
                <span className="grid h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-lg leading-none text-background-50">🍉</span>
                <span className="leading-none">
                  <span className="block font-heading text-xl font-black text-foreground-950">吃瓜王</span>
                  <span className="block pt-0.5 font-display text-[10px] tracking-[0.28em] text-primary-600">CHIGUA · KING</span>
                </span>
              </a>
              <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
                一个用趣味题目测试你八卦知识储备的答题社区。每天追热点、看名场面，答对的同时也把自己玩成真正的瓜界老手。
              </p>
              <div className="mt-4 flex items-center gap-2">
                {["ri-wechat-fill", "ri-weibo-fill", "ri-douban-line", "ri-bilibili-line"].map((c) => (
                  <a key={c} href="#top" aria-label="社交平台入口"
                    className="grid h-9 w-9 items-center justify-center rounded-md border border-background-300 bg-background-50 text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 cursor-pointer">
                    <i className={c} aria-hidden="true" />
                  </a>
                ))}
              </div>
            </div>

            {footerCols.map((col) => (
              <div key={col.title}>
                <h4 className="font-heading text-sm font-black uppercase tracking-widest text-foreground-950">
                  {col.title}
                </h4>
                <ul className="mt-4 space-y-2.5">
                  {col.links.map((l) => (
                    <li key={l}>
                      <a href="#top" className="inline-flex items-center gap-1.5 text-sm text-foreground-600 transition-colors hover:text-primary-600 cursor-pointer">
                        {l}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t border-background-300 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center">
            <p>© 2026 吃瓜王 · 内容仅供娱乐，请理性吃瓜</p>
            <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
              <a href="#top" className="hover:text-primary-600 cursor-pointer whitespace-nowrap">用户协议</a>
              <a href="#top" className="hover:text-primary-600 cursor-pointer whitespace-nowrap">隐私政策</a>
              <a href="#top" className="hover:text-primary-600 cursor-pointer whitespace-nowrap">举报与反馈</a>
              <span className="inline-flex items-center gap-1 text-foreground-400">
                <i className="ri-leaf-line" aria-hidden="true" />
                健康冲浪，快乐吃瓜
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}